export const SUB_ADMIN_GROUP_PERMISSION = [
  'MANAGE_MEMBER_ROLE',
  'MANAGE_MEMBER_MANAGEMENT',
  'MANAGE_USER_MANAGEMENT',
  'MANAGE_MFA_VERIFICATION',
  'MANAGE_REPORT_SECTION',
  'MANAGE_FORM_MANAGEMENT',
  'MANAGE_TRANSITION_PAGE',
  'MANAGE_MINIMUM_REQUIREMENTS',
  'MANAGE_SSO_USER_APPROVAL',
  'MANAGE_SSO_MEMBER_APPROVAL',
  'MANAGE_BILLABLE_TRACKING',
  'VIEW_HELP_CATEGORIES',
  'MANAGE_HELP_CATEGORY',
  'VIEW_HELP_POSTS',
  'MANAGE_HELP_POST',
  'VIEW_ARTICLES',
  'MANAGE_ARTICLES',
  'VIEW_HELP_ASSETS',
  'MANAGE_HELP_ASSETS',
  'VIEW_EULAS',
  'MANAGE_EULAS',
  'MANAGE_MAIN_PAGE',
  'VIEW_COMMUNICATION_TEMPLATE',
  'MANAGE_COMMUNICATION_TEMPLATE',
  'EXECUTE_COMMUNICATION_TEMPLATE',
  'EDIT_MEMBER_DEFINED_PROPERTIES',
  'VIEW_MANAGE_MEMBER',
  'VIEW_MEMBER_DEFINED_PROPERTIES',
  'VIEW_ACTIVITY_LOG_OF_USER',
  'DELETE_MEMBERS',
  'EDIT_MEMBER',
  'CREATE_MEMBER',
  'MANAGE_MEMBER_CATEGORIES',
  'IMPERSONATE_USER',
  'IMPERSONATE_MEMBER',
  'MANAGE_MEMBER_BILLING',
  'ASSIGN_AFFILIATE',
  'ASSIGN_PARTNER',
];

export const STYLED_BTN = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none',
  width: '20px',
  height: '20px',
};
